import React from 'react';
import Dialog from 'material-ui/Dialog';
import SelectFilter from '../Filter/SelectFilter';
import { ComplianceDialogs } from '../../constants/Dialogs';
import FlatButton from 'material-ui/FlatButton';
import DialogActions from '../../actions/DialogActionCreator';
import { assignUsersByFilter } from '../../actions/ComplianceActionCreator';
import { asDialog } from '../Common/Decorators';

const AssignUsersDialog = ({open, draft}) => {
    const { complianceId, filterId } = draft;
    const dialogActions = [
        <FlatButton key="cancel" label="Cancel" onTouchTap={() => DialogActions.close()} />,
        <FlatButton
            primary={true}
            key="submit"
            label="Assign"
            disabled={!complianceId || !filterId}
            onTouchTap={() => {assignUsersByFilter(complianceId, filterId).then(DialogActions.close())}}
        />
    ];

    return (
        <Dialog
            title="Assign users"
            open={open === ComplianceDialogs.ASSIGN_USERS}
            actions={dialogActions}
        >
            <SelectFilter
                label="Choose a filter"
                onSelect={(name, id) => DialogActions.updateDraft('filterId', id)}
                onUpdate={() => DialogActions.updateDraft('filterId', null)}
                clearOnSelect={false}
            />
        </Dialog>
    );

};

export default asDialog(AssignUsersDialog);
